'use strict';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/navigation';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/scrollbar';
class SwiperJs {
	constructor( $element, $config = {} ) {
		const $default = {
			modules: [ Navigation, Pagination, Scrollbar ],
		};
		const $elementObj = jQuery( $element );
		let $dataConfig = {};
		if ( $elementObj.length ) {
			$dataConfig = $elementObj.data( 'swiper' );
		}
		const $swiperConfig = {
			...$default,
			...$config,
			...$dataConfig,
		};
		// init Swiper:
		new Swiper( $element, $swiperConfig );
	}
}

export default SwiperJs;
